'use client'
import type { CSSProperties, FC } from 'react'
import React from 'react'
import styles from './ContentSheet.module.scss'

type Props = {
  children: React.ReactNode
  style: CSSProperties
  isFullscreen: boolean
}
export const ContentSheet: FC<Props> = ({ children, style, isFullscreen }) => (
  <div
    className={`${styles.contentSheet} ${isFullscreen ? styles.sheetFullscreen : ''}`}
    style={style}
  >
    {children}
  </div>
)
